import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { MDBDataTableV5, MDBCol, MDBTableBody, MDBTableHead } from "mdbreact";
import {
  MDBSelect,
  MDBSelectInput,
  MDBSelectOptions,
  MDBSelectOption,
} from "mdbreact";

import { Link } from "react-router-dom";

import Notiflix from "notiflix";
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import moment from "moment";
import Parser from "html-react-parser";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";

class cutomerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allDetails: [],
      isdeleted: false,
      searchInput: "",
      freqentMonthData: [
        { label: "Select Months", value: "" },
        { label: "01", value: "01" },
        { label: "02", value: "02" },
        { label: "03", value: "03" },
        { label: "04", value: "04" },
        { label: "05", value: "05" },
        { label: "06", value: "06" },
        { label: "07", value: "07" },
        { label: "08", value: "08" },
        { label: "09", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
        { label: "13", value: "13" },
        { label: "14", value: "14" },
        { label: "15", value: "15" },
      ],
      freqentMonthData2: [
        { label: "Select Months", value: "" },
        { label: "01", value: "01" },
        { label: "02", value: "02" },
        { label: "03", value: "03" },
        { label: "04", value: "04" },
        { label: "05", value: "05" },
        { label: "06", value: "06" },
        { label: "07", value: "07" },
        { label: "08", value: "08" },
        { label: "09", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
      ],
      Accountno: "",
      Duration: "",
      SchemeName: "",
      Amount: "",
      Name: "",
      Email: "",

      DecimalRegex: /^(\d*\.?\d{0,3}|\.\d{0,9})$/,
      NumRegex: /^[0-9]*$/,
      AlphaNumericRegex: /^[a-zA-Z0-9]*$/,
      EmailRegex:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      UrlRegex:
        /^(https:\/\/www\.|https:\/\/www\.|https:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
      Date: "",
      Weight: null,
      Usertype: "",
      TransactionIds: null,
      Mobile: "",
      FilterData: [
        { label: "Pending", value: "Pending" },
        { label: "Successfully Transfer", value: "Successfully Transfer" },
      ],
      StatusType: "",
      SelectDate: "",
      PaymentStatus: "",
      PaymentStatusData: [
        { label: "Received", value: "Received" },
        { label: "Failed", value: "Failed" },
      ],
      ChitScheme: "",
      TransactionNumber: null,
      Refund: false,
    };
  }

  componentDidMount() {
    Notiflix.Loading.Init({
      svgColor: "rgb(171, 61, 0)",
    });

    var login = localStorage.getItem("LoginDetail");
    var details = JSON.parse(login);
    // console.log(details[0])
    this.setState({
      Usertype: details[0].fld_usertype,
    });
    // console.log("this.state.Usertype  " + this.state.Usertype);
    if (details[0].fld_usertype != "Admin") {
      window.location.href = "/";
    }

    Notiflix.Loading.Dots("");

    GetApiCall.getRequest("Get_TransactionList").then((resultdes) =>
      resultdes.json().then((obj) => {
        // console.log(obj);
        this.setState(
          {
            allDetails: obj.data,
          },
          () => console.log(this.state.allDetails.length)
        );

        Notiflix.Loading.Remove();
      })
    );
  }

  SaveData() {
    // console.log(this.state.Duration)
    if (this.state.TransactionNumber !== null) {
      if (this.state.Duration !== "") {
        if (
          this.state.ChitScheme === "MY GOLD ELEVEN" ||
          this.state.ChitScheme === "My Gold Eleven" ||
          this.state.ChitScheme === "Thanga Then"
        ) {
          if (this.state.Weight !== null) {
            // console.log('hii2')
            this.AcknowledgementData();
          } else {
            Notiflix.Notify.Failure("Please Enter the weight.");
          }
        } else {
          //    console.log('hii')
          this.AcknowledgementData();
        }
      } else {
        Notiflix.Notify.Failure("Please Enter Installment No.");
      }
    } else {
      Notiflix.Notify.Failure("Please Enter Payment Transaction Number.");
    }
  }

  AcknowledgementData = () => {
    var login = localStorage.getItem("LoginDetail");
    var details = JSON.parse(login);

    Notiflix.Loading.Dots("Please wait...");
    PostApiCall.postRequest(
      {
        id: this.state.TransactionIds,
        installmentno: this.state.Duration,
        accountno: this.state.Accountno,
        weight: this.state.Weight,
        status:
          this.state.Refund == false ? "Payment Approved" : this.state.Refund,
        userid: details[0].fld_userid,
        transactionNumber: this.state.TransactionNumber,
      },
      "Update_Transaction"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          //    console.log(obj.data)
          if (this.state.Refund == false) {
            this.onPostPaymentSms();
          } else {
            this.onPostMailer();
          }
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Loading.Failure(obj.data);
        }
        //    }
      })
    );
  };

  onPostPaymentSms = () => {
    Notiflix.Loading.Remove();

    fetch(
      // "http://sms.messagewall.in/api/v2/sms/send?access_token=f6da7c3df035f743f0f2cbf24d1d6495&to=" +
      "https://api.co3.live/api/smsapi?key=0228b2bd609b68fa69a1c13680445924"  +
        "&sms= Dear " +
        this.state.Name +
        ", Received Remittance for Savings Scheme Book Number " +
        this.state.Accountno +
        " Rs " +
        this.state.Amount +
        " Receipt Email will be sent shortly" +
        " Regards " +
        `Shanthi Jewellers&route=2&sender=SANTII&number=${this.state.Mobile}&templateid=1707161917439263687`
      // " Shanthi Jewellers&service=T&sender=SANTII&template_id=1707161917439263687"
    ).then((res) => res.json());
    //   console.log(res.json())
    Notiflix.Loading.Dots("Please wait...");

    PostApiCall.postRequest(
      {
        name: this.state.Name,
        email: this.state.Email,
        paymentDate: this.state.Date,
        installment: this.state.Duration,
        accountNumber: this.state.Accountno,
        amount: this.state.Amount,
        weight: this.state.Weight,
        paymentStatus:
          this.state.Refund == false
            ? "Payment Successfully Approved"
            : "Payment has been successfully refunded",
      },
      "PaymentApproval_Mailer"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          //    console.log(obj.data)

          Notiflix.Loading.Remove();
          Notiflix.Notify.Success("Acknowledgment Successfully sent.");
          window.location.reload();
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Loading.Failure(obj.data);
        }
      })
    );
  };

  onPostMailer = () => {
    Notiflix.Loading.Dots("Please wait...");

    PostApiCall.postRequest(
      {
        name: this.state.Name,
        email: this.state.Email,
        paymentDate: this.state.Date,
        installment: this.state.Duration,
        accountNumber: this.state.Accountno,
        amount: this.state.Amount,
        weight: this.state.Weight,
        paymentStatus:
          this.state.Refund == false
            ? "Payment Successfully Approved"
            : "Payment has been successfully refunded",
      },
      "PaymentApproval_Mailer"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          //    console.log(obj.data)

          Notiflix.Loading.Remove();
          Notiflix.Notify.Success("Acknowledgment Successfully sent.");
          window.location.reload();
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Loading.Failure(obj.data);
        }
      })
    );
  };

  //     onPostAcknowledgement_Mailer=()=>{

  //         Notiflix.Loading.Dots('Please wait...');

  //         PostApiCall.postRequest ({
  //              name : this.state.Name,
  //              email : this.state.Email,
  //              paymentDate : this.state.Date,
  //              installment : this.state.Duration,
  //              accountNumber:this.state.Accountno,
  //              amount:this.state.Amount,
  //              weight : this.state.Weight

  //         },"PaymentApproval_Mailer").then((result) =>
  //         result.json().then(obj => {
  //             if(result.status == 200 || result.status == 201){

  //                 Notiflix.Loading.Remove();
  //                 Notiflix.Notify.Success('User is  successfully rejected.')
  //                 window.location.reload()
  //             }else
  //             {
  //                 Notiflix.Loading.Remove();
  //                     Notiflix.Loading.Failure(obj.data);
  //             }
  //         })
  //         )

  // }

  seachBarHandler = (e) => {
    this.setState({ ...this.state, searchInput: e.target.value });
  };

  render() {
    const data = {
      columns: [
        {
          label: "S.No.",
          field: "serial",
          sort: "disabled",
          width: 150,
        },
        {
          label: "Name",
          field: "name",
          sort: "disabled",
          width: 270,
        },
        {
          label: "Email",
          field: "email",
          sort: "disabled",
          width: 270,
        },

        {
          label: "Saving Book Number",
          field: "savingbooknumber",
          sort: "disabled",
          width: 200,
        },
        {
          label: "Transaction ID",
          field: "transactionid",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Paid Amount",
          field: "paidamount",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Paid Date",
          field: "paiddate",
          sort: "disabled",
          width: 100,
        },
        {
          label: "Status",
          field: "status",
          sort: "disabled",
          width: 150,
        },
        {
          label: <div class="text-center">Action</div>,
          field: "action",
          sort: "disabled",
          width: 100,
        },
      ],
      rows:
        this.state.allDetails.push &&
        [...this.state.allDetails]
          .filter((data) => {
            if (this.state.searchInput.length == 0) {
              return data;
            }
            if (
              this.state.searchInput !== "" &&
              (data.fld_name
                .toLowerCase()
                .includes(this.state.searchInput.toLowerCase()) ||
                `${
                  data.fld_accountno ? data.fld_accountno.toLowerCase() : ""
                }`.includes(this.state.searchInput.toLowerCase()) ||
                `${
                  data.fld_chitschema ? data.fld_chitschema.toLowerCase() : ""
                }`.includes(this.state.searchInput.toLowerCase()) ||
                `${data.status ? data.status.toLowerCase() : ""}`.includes(
                  this.state.searchInput.toLowerCase()
                ) ||
                `${
                  data.fld_email ? data.fld_email.toLowerCase() : ""
                }`.includes(this.state.searchInput.toLowerCase()) ||
                `${data.transid ? data.transid.toLowerCase() : ""}`.includes(
                  this.state.searchInput.toLowerCase()
                ) ||
                `${data.paidamount ? data.paidamount : ""}`.includes(
                  this.state.searchInput.toLowerCase()
                ))
            ) {
              //   console.log('searchdata' + data)
              return data;
            }
          })
          .map((data, i) => {
            return {
              serial: <td>{i + 1}</td>,
              name: <td>{data.fld_name}</td>,
              email: <td>{data.fld_email}</td>,
              savingbooknumber: <td>{data.fld_accountno}</td>,
              transactionid: <td>{data.transid}</td>,
              paidamount: <td>{data.paidamount}</td>,
              paiddate: <td>{moment(data.paiddate).format("DD-MM-YYYY, HH:mm")}</td>,
              status: <td>{data.status}</td>,
              action: (
                <div className="d-flex justify-content-center">
                  <td className="text-center actionuser">
                    <button
                      className={"btn"}
                      type="submit"
                      style={{
                        backgroundColor: "#880105",
                        color: "#e1b761",
                        float: "left",
                        marginLeft: "5px",
                        display: data.status === "Pending" ? "block" : "none",
                      }}
                      onClick={() => {
                        confirmAlert({
                          title: "Confirm to Failed",
                          message:
                            "Are you sure you want to cancel this payment.",
                          buttons: [
                            {
                              label: "Yes",
                              onClick: () => {
                                var login = localStorage.getItem("LoginDetail");
                                var details = JSON.parse(login);
                                Notiflix.Loading.Dots("Please wait...");
                                PostApiCall.postRequest(
                                  {
                                    id: data.fld_transaction_id,
                                    installmentno: 0,
                                    accountno: data.fld_accountno,
                                    weight: null,
                                    status: "Failed",
                                    userid: details[0].fld_userid,
                                    transactionNumber: data.transid,
                                  },
                                  "Update_Transaction"
                                ).then((result) =>
                                  result.json().then((obj) => {
                                    if (
                                      result.status === 200 ||
                                      result.status === 201
                                    ) {
                                      //    console.log(obj.data)
                                      Notiflix.Loading.Remove();
                                      Notiflix.Notify.Success(
                                        "Payment is Failed."
                                      );

                                      window.location.reload();
                                    } else {
                                      Notiflix.Loading.Remove();
                                      Notiflix.Notify.Failure(obj.data);
                                    }
                                  })
                                );
                              },
                            },
                            {
                              label: "No",
                              // onClick: () => alert('Click No')
                            },
                          ],
                        });
                      }}
                    >
                      Failed
                    </button>
                  </td>
                  <td>
                    <button
                      className={"btn"}
                      type="submit"
                      style={{
                        backgroundColor: "#880105",
                        color: "#e1b761",
                        float: "right",
                        marginRight: "2%",
                      }}
                      onClick={() => {
                        this.setState({
                          Name: data.fld_name,
                          Accountno: data.fld_accountno,
                          ID: data.fld_id,
                          open: true,
                          Email: data.fld_email,
                          Mobile: data.fld_mobile,
                          ChitId: data.clientid,
                          // Duration:data.fld_installment_id,
                          SchemeName: data.fld_chitschema,
                          Amount: data.paidamount,
                          Date: data.paiddate,
                          TransactionNumber: data.transid,
                          TransactionIds: data.fld_transaction_id,
                          ChitScheme: data.fld_chitschema,
                        });
                        //  console.log(data.fld_installment_id)
                      }}
                    >
                      Send
                    </button>
                  </td>
                </div>
              ),
            };
          }),
    };

    // console.log(this.state.Refund==false?'Payment Successfully Approved':'Payment has been successfully refunded')
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Modal class="modal-content" open={this.state.open} center>
              <div class="modal-content modelcontent3">
                <div class="modal-header">
                  <h4 class="modal-title">Send Acknowledgement</h4>
                </div>
                <div class="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Transaction Id <span style={{ color: "red" }}>*</span>
                        </label>

                        <input
                          type="text"
                          class="form-control"
                          value={this.state.TransactionNumber}
                          onChange={(id) => {
                            this.setState({
                              TransactionNumber: id.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div
                      class="col-md-6"
                      style={{
                        display:
                          this.state.SchemeName != "My Gold Eleven"
                            ? ""
                            : "none",
                      }}
                    >
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Installment No.{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          className="form-control"
                          value={this.state.Duration}
                          onChange={(text) => {
                            this.setState({
                              Duration: text.target.value,
                            });
                          }}
                        >
                          {this.state.freqentMonthData.map((data) => {
                            return (
                              <option key={data.label} value={data.value}>
                                {data.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    <div
                      class="col-md-6"
                      style={{
                        display:
                          this.state.SchemeName === "My Gold Eleven"
                            ? ""
                            : "none",
                      }}
                    >
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Installment No.{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <select
                          className="form-control"
                          value={this.state.Duration}
                          onChange={(text) => {
                            this.setState({
                              Duration: text.target.value,
                            });
                          }}
                        >
                          {this.state.freqentMonthData2.map((data) => {
                            return (
                              <option key={data.label} value={data.value}>
                                {data.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div
                      class="col-md-6"
                      style={{
                        display:
                          this.state.ChitScheme === "MY GOLD ELEVEN" ||
                          this.state.ChitScheme === "My Gold Eleven" ||
                          this.state.ChitScheme === "Thanga Then"
                            ? "block"
                            : "none",
                      }}
                    >
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Weight Credited{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.Weight}
                          onChange={(weight) => {
                            if (
                              this.state.DecimalRegex.test(weight.target.value)
                            ) {
                              this.setState({
                                Weight: weight.target.value,
                              });
                            }
                          }}
                        />
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group mb-3">
                        <label for="validationCustom01">
                          Scheme Account Number{" "}
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.Accountno}
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group mb-3">
                        <label for="validationCustom01">Scheme Amount</label>
                        <input
                          type="text"
                          class="form-control"
                          value={this.state.Amount}
                          disabled
                        />
                      </div>
                    </div>

                    <div class="col-md-12">
                      <div class="form-group mb-3">
                        <input
                          type="checkbox"
                          class=""
                          checked={this.state.Refund}
                          onChange={() => {
                            this.setState({
                              Refund: !this.state.Refund,
                            });
                          }}
                          style={{ verticalAlign: "middle" }}
                        />
                        <label
                          class="form-check-label"
                          for="exampleCheck1"
                          style={{ verticalAlign: "middle", marginLeft: "5px" }}
                        >
                          Is this payment refunded
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    className={"btn"}
                    type="submit"
                    style={{
                      float: "right",
                      backgroundColor: "#880105",
                      color: "#e1b761",
                    }}
                    onClick={() => {
                      this.setState({
                        open: false,
                      });
                    }}
                  >
                    Close
                  </button>

                  <button
                    className={"btn"}
                    type="submit"
                    style={{
                      float: "right",
                      backgroundColor: "#880105",
                      color: "#e1b761",
                      display: this.state.Usertype == "Admin" ? "" : "none",
                    }}
                    onClick={this.SaveData.bind(this)}
                  >
                    Send Acknowledgement
                  </button>
                  <span></span>
                </div>
              </div>
            </Modal>

            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={"Manage Clients"}
              breadcrumbItem={"Transactions List"}
            />
            <Row>
              <Col xl="12">
                <Card className="overflow-hidden">
                  <div
                    className="maxXchange-bg-soft-pink"
                    style={{ background: "rgb(171, 61, 0)" }}
                  >
                    <Row>
                      <Col xs="6">
                        <div className="maxXchange-text p-3">
                          <h5 className="maxXchange-text">Transactions </h5>
                        </div>
                      </Col>
                    </Row>
                    <Row></Row>
                  </div>

                  <Card className="overflow-hidden">
                    <div
                      className="maxXchange-bg-soft-pink"
                      style={{ background: "#dfb65c" }}
                    >
                      <Row>
                        <Col xs="6">
                          <div className="maxXchange-text p-3">
                            <h5 className="maxXchange-text">
                              Transactions List
                            </h5>
                          </div>
                        </Col>
                      </Row>
                    </div>
                    <CardBody className="pt-0">
                      <Row>
                        <MDBCol
                          md="4"
                          style={{ marginBottom: "10px", marginTop: "10px" }}
                        >
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Search"
                            aria-label="Search"
                            onChange={(e) => this.seachBarHandler(e)}
                            value={this.state.searchInput}
                          />
                        </MDBCol>

                        <Col md="12">
                          <MDBDataTableV5
                            striped
                            bordered
                            small
                            data={data}
                            searchBottom={false}
                            seachTop={true}
                          >
                            <MDBTableHead columns={data.columns} />
                            <MDBTableBody rows={data.rows} />
                          </MDBDataTableV5>
                        </Col>
                        {/* <Col md="12">
                          <div class="table-responsive">

                            <table class="table table-bordered">
                              <thead>
                                <tr>
                                  <th>S.No.</th>
                                  <th>Name</th>
                                  <th>Email</th>
                                  <th>Saving Book Number</th>
                                  <th>Transaction ID</th>
                                  <th>Paid Amount</th>
                                  <th>Paid Date</th>
                                  <th>Status</th>
                                  <th>Action</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.allDetails.push &&
                                  [...this.state.allDetails]
                                    .filter((data) => {
                                      if (this.state.searchInput.length == 0) {
                                        return data;
                                      }
                                      if (
                                        this.state.searchInput !== "" &&
                                        (data.fld_name
                                          .toLowerCase()
                                          .includes(
                                            this.state.searchInput.toLowerCase()
                                          ) ||
                                          `${
                                            data.fld_accountno
                                              ? data.fld_accountno.toLowerCase()
                                              : ""
                                          }`.includes(
                                            this.state.searchInput.toLowerCase()
                                          ) ||
                                          `${
                                            data.fld_chitschema
                                              ? data.fld_chitschema.toLowerCase()
                                              : ""
                                          }`.includes(
                                            this.state.searchInput.toLowerCase()
                                          ) ||
                                          `${
                                            data.status
                                              ? data.status.toLowerCase()
                                              : ""
                                          }`.includes(
                                            this.state.searchInput.toLowerCase()
                                          ) ||
                                          `${
                                            data.fld_email
                                              ? data.fld_email.toLowerCase()
                                              : ""
                                          }`.includes(
                                            this.state.searchInput.toLowerCase()
                                          ) ||
                                          `${
                                            data.transid
                                              ? data.transid.toLowerCase()
                                              : ""
                                          }`.includes(
                                            this.state.searchInput.toLowerCase()
                                          ) ||
                                          `${
                                            data.paidamount
                                              ? data.paidamount
                                              : ""
                                          }`.includes(
                                            this.state.searchInput.toLowerCase()
                                          ))
                                      ) {
                                        //   console.log('searchdata' + data)
                                        return data;
                                      }
                                    })
                                    .map((data, i) => {
                                      return (
                                        <tr>
                                          <td>{i + 1}</td>
                                          <td>{data.fld_name}</td>
                                          <td>{data.fld_email}</td>
                                          <td>{data.fld_accountno}</td>

                                          <td>{data.transid}</td>
                                          <td>{data.paidamount}</td>
                                          <td>{data.paiddate}</td>
                                          <td>{data.status}</td>
                                          <td className="text-center actionuser">
                                            <button
                                              className={"btn"}
                                              type="submit"
                                              style={{
                                                backgroundColor: "#880105",
                                                color: "#e1b761",
                                                float: "left",
                                                marginLeft: "5px",
                                                display:
                                                  data.status === "Pending"
                                                    ? "block"
                                                    : "none",
                                              }}
                                              onClick={() => {
                                                confirmAlert({
                                                  title: "Confirm to Failed",
                                                  message:
                                                    "Are you sure you want to cancel this payment.",
                                                  buttons: [
                                                    {
                                                      label: "Yes",
                                                      onClick: () => {
                                                        var login =
                                                          localStorage.getItem(
                                                            "LoginDetail"
                                                          );
                                                        var details =
                                                          JSON.parse(login);
                                                        Notiflix.Loading.Dots(
                                                          "Please wait..."
                                                        );
                                                        PostApiCall.postRequest(
                                                          {
                                                            id: data.fld_transaction_id,
                                                            installmentno: 0,
                                                            accountno:
                                                              data.fld_accountno,
                                                            weight: null,
                                                            status: "Failed",
                                                            userid:
                                                              details[0]
                                                                .fld_userid,
                                                            transactionNumber:
                                                              data.transid,
                                                          },
                                                          "Update_Transaction"
                                                        ).then((result) =>
                                                          result
                                                            .json()
                                                            .then((obj) => {
                                                              if (
                                                                result.status ===
                                                                  200 ||
                                                                result.status ===
                                                                  201
                                                              ) {
                                                                //    console.log(obj.data)
                                                                Notiflix.Loading.Remove();
                                                                Notiflix.Notify.Success(
                                                                  "Payment is Failed."
                                                                );

                                                                window.location.reload();
                                                              } else {
                                                                Notiflix.Loading.Remove();
                                                                Notiflix.Notify.Failure(
                                                                  obj.data
                                                                );
                                                              }
                                                            })
                                                        );
                                                      },
                                                    },
                                                    {
                                                      label: "No",
                                                      // onClick: () => alert('Click No')
                                                    },
                                                  ],
                                                });
                                              }}
                                            >
                                              Failed
                                            </button>
                                          </td>
                                          <td>
                                            <button
                                              className={"btn"}
                                              type="submit"
                                              style={{
                                                backgroundColor: "#880105",
                                                color: "#e1b761",
                                                float: "right",
                                                marginRight: "2%",
                                              }}
                                              onClick={() => {
                                                this.setState({
                                                  Name: data.fld_name,
                                                  Accountno: data.fld_accountno,
                                                  ID: data.fld_id,
                                                  open: true,
                                                  Email: data.fld_email,
                                                  Mobile: data.fld_mobile,
                                                  ChitId: data.clientid,
                                                  // Duration:data.fld_installment_id,
                                                  SchemeName:
                                                    data.fld_chitschema,
                                                  Amount: data.paidamount,
                                                  Date: data.paiddate,
                                                  TransactionNumber:
                                                    data.transid,
                                                  TransactionIds:
                                                    data.fld_transaction_id,
                                                  ChitScheme:
                                                    data.fld_chitschema,
                                                });
                                                //  console.log(data.fld_installment_id)
                                              }}
                                            >
                                              Send
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })}
                              </tbody>
                            </table>
                          </div>
                        </Col> */}
                      </Row>
                    </CardBody>
                  </Card>

                  {/* <WelcomeComp /> */}
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default cutomerList;
